const MedicAtentionsGroup = () => /* webpackChunkName: "EmptyRouterView" */ import("@/views/medic_hosp/medic_atention/medicAtentionsGroup.vue");
const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/mental_health_medic/EmptyRouterView.vue");
const MentalMedicHealthHome = () => /* webpackChunkName: "Home" */ import("./../views/mental_health_medic/Home.vue");
const MentalHealthArchive = () =>
  /* webpackChunkName: "MentalHealthArchive" */ import("./../views/mental_health_medic/mental_health_archive/MentalHealthArchive.vue");
const ProfesionalManteiner = () => /* webpackChunkName: "ProfesionalManteiner" */ import("./../views/mental_health_medic/ProfesionalManteiner.vue");
const MedicAtention = () => /* webpackChunkName: "MedicAtentions" */ import("./../views/mental_health_medic/medic_atention/medicAtentions.vue");
const RegisterAtentions = () => /* webpackChunkName: "registerAtentions" */ import("./../views/mental_health_medic/registerAtention/registerAtentions.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/mental_health_medic",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "mentalMedicHealthHome",
        component: MentalMedicHealthHome,
      },
      {
        path: "atencionMedica",
        name: "mentalMedicHealthHomeMedicAtention",
        component: MedicAtention,
      },
      {
        path: "cartola-salud-mental",
        name: "archiveMentalHealth",
        component: MentalHealthArchive,
      },
      {
        path: "mantenedor-profesionales",
        name: "profesionalManteinerMentalHealth",
        component: ProfesionalManteiner,
      },
      {
        path: "atencionMedica",
        name: "mentalHealthMedicAtention",
        component: MedicAtention,
      },
      {
        path: "registro-antecedentes",
        name: "mentalHealthRegisterAtentions",
        component: RegisterAtentions,
      },
      {
        path: "documentacion",
        name: "mentalHealthMedicDocumentation",
        component: Document,
      },
      {
        path: "atencionMedicaGrupo",
        name: "MedicAtentionGroup",
        component: MedicAtentionsGroup,
      },
    ],
  },
];
